/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { literal } from '../util.type';

/**
 * Číselník formátů pro aktualizaci aplikace.
 * @enum {'HTML' | 'IPK' | 'WGT' | 'ZIP'}
 * @readonly
 */
const FormatEnum = {
  HTML: literal('HTML'),
  IPK: literal('IPK'),
  WGT: literal('WGT'),
  ZIP: literal('ZIP')
};

export default FormatEnum;
